import { useParams } from "react-router-dom";
import "./customer-home.styles.scss";
import { useContext, useEffect, useState } from "react";
import { CustomerMenuContext } from "../../../contexts/customerMenu.context";
import CustomerHomeMenu from "../customer-home-menu/customer-home-menu.component";
import { CustomerOrderContext } from "../../../contexts/customerOrder.context";
import CustomerHomeCheckout from "../customer-home-checkout/customer-home-checkout.component";
const CustomerHome = ({ orderType }) => {
  var { id } = useParams();
  const [currentPane, setCurrentPane] = useState("menu");
  const [menuButtonClass, setMenuButtonClass] = useState(
    "ch-mobile-button active"
  );
  const [checkoutButtonClass, setCheckoutButtonClass] =
    useState("ch-mobile-button");
  const { getMenu } = useContext(CustomerMenuContext);
  const { setOrderType, orderTotal } = useContext(CustomerOrderContext);
  useEffect(() => {
    getMenu(id);
    setOrderType(orderType);
  }, []);
  const handleClick = (pane) => {
    setCurrentPane(pane);
    if (pane === "menu") {
      setMenuButtonClass("ch-mobile-button active");
      setCheckoutButtonClass("ch-mobile-button");
    } else if (pane === "checkout") {
      setMenuButtonClass("ch-mobile-button");
      setCheckoutButtonClass("ch-mobile-button active");
    }
  };
  return (
    <div className="ch-container">
      {window.innerWidth > 1024 ? (
        <div className="ch-desktop">
          <div className="ch-left">
            <CustomerHomeMenu />
          </div>
          <div className="ch-right">
            <CustomerHomeCheckout />
          </div>
        </div>
      ) : (
        <div className="ch-mobile">
          <div className="ch-mobile-buttons">
            <span
              className={menuButtonClass}
              onClick={() => handleClick("menu")}
            >
              Menu
            </span>
            <span
              className={checkoutButtonClass}
              onClick={() => handleClick("checkout")}
            >
              Checkout
            </span>
          </div>
          {currentPane === "menu" ? (
            <div className="ch-left">
              <CustomerHomeMenu />
              <div className="ch-checkout-bottom">
                <span className="ch-checkout-ordertotal">
                  <span className="ch-checkout-tag">Order Total : </span>
                  {orderTotal}
                </span>
                <span
                  className="ch-checkout-button"
                  onClick={() => handleClick("checkout")}
                >
                  GO TO CHECKOUT
                </span>
              </div>
            </div>
          ) : (
            <div className="ch-right">
              <CustomerHomeCheckout />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default CustomerHome;
